import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppConfig } from '../../../app.config';
import { DescriptionModel } from '../base.model';
import { Model, ModelFactory } from '@angular-extensions/model';

import { Client, Filedescriptions, SSISPackages, SFTPInfo, ClientsAPIandSFTP, Filetype, Filedescription, APIConfigurationModel, ClientFileInfoModel, Hash } from './client.model';


const SortClientByName = (a: Hash, b: Hash) => {
  if (a.id == -1 || b.id == -1)
    return 1;

  const nameA = a.description.toLocaleLowerCase();
  const nameB = b.description.toLocaleLowerCase();

  return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
};

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private model: Model<Client[]>;
  clients$: Observable<Client[]>;
  public allClientModels: Client[] = [];
  private isTitleChangedSubject: BehaviorSubject<string>;
  public isTitleChanged$: Observable<string>;
  private isClientChangedSubject: BehaviorSubject<number>;
  public isClientChanged$: Observable<number>;
  strfiledescriptions: Filedescriptions[];
  CurrentClientSubject: BehaviorSubject<Client>;
  CurrentClientInfo$: Observable<Client>;

  constructor(
    private modelFactory: ModelFactory<Client[]>,
    private http: HttpClient, private toastrService: ToastrService) {
    this.isTitleChangedSubject = new BehaviorSubject<string>('');
    this.isTitleChanged$ = this.isTitleChangedSubject.asObservable();
    this.isClientChangedSubject = new BehaviorSubject<number>(-1);
    this.isClientChanged$ = this.isClientChangedSubject.asObservable();
  }

  createClient(payload: Client): Observable<any> {
    return this.http
      .post<Client>(
        `${AppConfig.settings.settings.apiEndpoint}api/Client/CreateClient`,
        payload
      )
      .pipe(
        map(value => {
          if (value) {
            this.toastrService.success('Saved Successfully.', '');
          } else {
            this.toastrService.error('Save Failed', 'Error');
          }
          return value;
        })
      );
  }

  getAllClients(): Observable<Client[]> {
    return this.http
      .get<Client[]>(`${AppConfig.settings.settings.apiEndpoint}api/Client/GetAllClients`)
      .pipe(
        map(value => {
          this.model = this.modelFactory.create([...value]);
          this.clients$ = this.model.data$;
          this.allClientModels = value;
          return value;
        })
      );
  }

  getClientInfoDescriptions(): Observable<DescriptionModel[]> {
    return this.http
      .get<DescriptionModel[]>(
        `${AppConfig.settings.settings.apiEndpoint}api/Client/GetClientInfoDescriptions`
      )
      .pipe(
        map(value => {
          return value;
        })
      );
  }


  public CheckEmailexisting(value: string) {
    if (value.trim() === '') return of(false);
    return this.http.get<boolean>(AppConfig.settings.settings.apiEndpoint + 'api/User/CheckUserEmail/' + value).pipe(map(data => {
      console.log("CheckEmailexisting", data);
      return data;
    }));
  }

  getCurrentClient(): Observable<Client> {
    return this.http
      .get<Client>(`${AppConfig.settings.settings.apiEndpoint}api/Client/GetCurrentClient`)
      .pipe(
        map(value => {
          return value;
        })
      );
  }

  Getfiletype(): Observable<Filetype[]> {
    return this.http.get<Filetype[]>(`${AppConfig.settings.settings.apiEndpoint}api/Client/FileTypes`).pipe(map(data => data), catchError(err => { throw err; }));
  }

  GetSFTPInfo():Observable<SFTPInfo[]>
  {
    //return this.http.get<SFTPInfo[]>(`${AppConfig.settings.settings.apiEndpoint}api/Clients/SFTPInfos`).pipe(map(data =>data),catchError(err => {throw err;}));
    return this.http.get<SFTPInfo[]>(`${AppConfig.settings.settings.apiEndpoint}api/SftpInfo/GetSftpInfos`).pipe(map(data =>data),catchError(err => {throw err;}));
  }

  GetSSISPackages(): Observable<SSISPackages[]> {
    return this.http.get<SSISPackages[]>(`${AppConfig.settings.settings.apiEndpoint}api/Client/GetAllSSISPackages`).pipe(map(data => data), catchError(err => { throw err; }));
  }

  getProductTypeDescriptions(clientInfoId: number): Observable<DescriptionModel[]> {
    return this.http
      .get<DescriptionModel[]>(
        `${AppConfig.settings.settings.apiEndpoint}api/Client/GetProductTypeDescriptions/${clientInfoId}`
      )
      .pipe(
        map(value => {
          return value;
        })
      );
  }


  GetAllFileDescription(): Observable<Filedescriptions[]> {
    return this.http.get<Filedescriptions[]>(`${AppConfig.settings.settings.apiEndpoint}api/Client/GetAllFileDescription/`).pipe(map(data => {
      this.strfiledescriptions = data;
      return data;
    }), catchError(err => { throw err; }));
  }

  GetClientInputFileInfos(clientid: number):Observable<string[][]>
  {
    return this.http.get<string[][]>(`${AppConfig.settings.settings.apiEndpoint}api/ClientFileInfo/GetClientInputFileInfoByClientId/${clientid}`).pipe(map(data =>{
      return data;
    }),catchError(err => {throw err;}));   
    
  }

  getClientInfoById(payload: number): Observable<Client> {

    return this.http.get<Client>(`${AppConfig.settings.settings.apiEndpoint}api/Client/GetClientInfoById/${payload}`).pipe(map(data => {
      const clients = this.model.get();
      const indexToUpdate = clients.findIndex(client => client.id === payload);
      clients[indexToUpdate] = data;
      this.model.set(clients);
      this.GetAllFileDescription();

      if (this.CurrentClientInfo$) {
        this.CurrentClientSubject.next(data);
      }
      else {
        this.CurrentClientSubject = new BehaviorSubject<Client>(data);
        this.CurrentClientInfo$ = this.CurrentClientSubject.asObservable();
      }
      return data;
    }));

  }

  retrieveClientById(payload: number): Observable<Client> {

    return this.http.get<Client>(`${AppConfig.settings.settings.apiEndpoint}api/Client/GetClientInfoById/${payload}`).pipe(map(data => {
      const clients = this.model.get();
      const indexToUpdate = clients.findIndex(client => client.id === payload);
      clients[indexToUpdate] = data;
      this.model.set(clients);
      this.GetAllFileDescription();

      if (this.CurrentClientInfo$) {
        this.CurrentClientSubject.next(data);
      }
      else {
        this.CurrentClientSubject = new BehaviorSubject<Client>(data);
        this.CurrentClientInfo$ = this.CurrentClientSubject.asObservable();
      }
      return data;
    }));

  }

  getClientInfoHash(): Observable<Hash[]> {
    return this.http.get<Hash[]>(`${AppConfig.settings.settings.apiEndpoint}api/Client/GetClientInfoHash`)
      .pipe(map(value => {
        return value.sort(SortClientByName)
      }));
  }

  createOrUpdateClientFileInfo(payload: ClientFileInfoModel): Observable<ClientFileInfoModel> {
    if (payload.id === -1) {
      return this.http.post<ClientFileInfoModel>(`${AppConfig.settings.settings.apiEndpoint}api/ClientFileInfo/InsertOrUpdateClientFileInfo`, payload).pipe(map(data => {
        this.toastrService.success("File Created Successfully.");
        return data;
      }));
    }

    return this.http.post<ClientFileInfoModel>(`${AppConfig.settings.settings.apiEndpoint}api/ClientFileInfo/InsertOrUpdateClientFileInfo`, payload).pipe(map(data => {
      this.toastrService.success("Updated Successfully.");
      return data;
    }));

  }

  //GetClientInputFileInfos(clientid: number): Observable<string[][]> {
  //  return this.http.get<string[][]>(`${AppConfig.settings.settings.apiEndpoint}api/ClientFileInfo/GetClientInputFileInfoByClientId/${clientid}`).pipe(map(data => {
  //    return data;
  //  }), catchError(err => { throw err; }));
  //}

  
  removeClientFileInfo(fileid: number, updatedby: string): Observable<boolean> {
    return this.http.get<boolean>(AppConfig.settings.settings.apiEndpoint + 'api/ClientFileInfo/DeleteClientFileInfo?clientfileid=' + fileid + '&updatedby=' + updatedby).pipe(map(data => {
      console.log("Check delete return", data);
      if (data === true) {
        this.toastrService.success("Deleted Successfully.");
      }
      return data;
    }));
  }


  setClientChanged(value: number) {
    this.isClientChangedSubject.next(value);
  }

  setTitleChanged(value: string) {
    this.isTitleChangedSubject.next(value);
  }

  updateClient(clientInfoModel: Client): Observable<any> {
    return this.http
      .post<Client>(
        `${AppConfig.settings.settings.apiEndpoint}api/Client/UpdateClient`,
        clientInfoModel
      )
      .pipe(
        map(value => {
          if (value) {
            this.toastrService.success('Saved Successfully.', '');
          } else {
            this.toastrService.error('Save Failed', 'Error');
          }
          return value;
        })
      );
  }
}
